import { NgModule } from '@angular/core';
import { LibBinIconComponent } from './lib-bin-icon.component';

@NgModule({
  declarations: [LibBinIconComponent],
  imports: [],
  exports: [LibBinIconComponent],
})
export class LibBinIconModule {}
